import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { demandPredictionApi, inventoryDashboardApi } from '../services/inventoryApi';

export const inventoryDashboardKeys = {
  all: ['inventory-dashboard'] as const,
  data: () => [...inventoryDashboardKeys.all, 'data'] as const,
  aiSuggestions: () => [...inventoryDashboardKeys.all, 'ai-suggestions'] as const,
};

export function useInventoryDashboard() {
  return useQuery({
    queryKey: inventoryDashboardKeys.data(),
    queryFn: inventoryDashboardApi.get,
    staleTime: 30 * 1000,
  });
}

export function useReplayFailedGLPostings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: inventoryDashboardApi.replayFailedGLPostings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: inventoryDashboardKeys.all });
    },
  });
}

// W9 — AI customer-aware demand predictions

export function useAiDemandSuggestions() {
  return useQuery({
    queryKey: inventoryDashboardKeys.aiSuggestions(),
    queryFn: () => demandPredictionApi.listSuggestions(5),
    staleTime: 60 * 1000,
  });
}

export function usePrePositionStock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (predictionId: string) => demandPredictionApi.prePosition(predictionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: inventoryDashboardKeys.aiSuggestions() });
    },
  });
}

export function useNotifyAccountExecutive() {
  return useMutation({
    mutationFn: (predictionId: string) => demandPredictionApi.notifyAe(predictionId),
  });
}

export function useDismissSuggestion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (predictionId: string) => demandPredictionApi.dismiss(predictionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: inventoryDashboardKeys.aiSuggestions() });
    },
  });
}
